/**
 * Texts for the directory pages, the 404 page, the extended profile block and "Despre noi".
 * Mirror of backend/siteCopy.php (the server renders the same texts) - keep both in sync.
 */
export const SITE_COPY = {
    "rom": {
        "nav": {
            "home": "Acasă",
            "directory": "Domenii și țări"
        },
        "home": {
            "browseCategories": "Explorează după domeniu",
            "browsePlaces": "Explorează după țară",
            "browseAll": "Vezi toate domeniile și țările"
        },
        "profile": {
            "category": "Domeniu:",
            "sources": "Surse",
            "updated": "Ultima actualizare:",
            "reportIssue": "Ai observat o inexactitate sau dorești completarea profilului?",
            "reportIssueLink": "Scrie-ne"
        },
        "directory": {
            "title": "Domenii și țări",
            "breadcrumb": "Domenii și țări",
            "intro": "Baza noastră de date cuprinde {{total}} ale femeilor originare din Republica Moldova, grupate în {{categories}} de activitate și {{places}} în care își desfășoară activitatea. Alege un domeniu sau o țară pentru a vedea profilurile.",
            "categoriesTitle": "Domenii de activitate",
            "placesTitle": "Țări",
            "categoryTitle": "{{name}} — femei de succes din Republica Moldova",
            "placeTitle": "Femei de succes din Republica Moldova în {{name}}",
            "categoryHeading": "Domeniu: {{name}}",
            "placeHeading": "Țară: {{name}}",
            "categoryIntro": "În domeniul „{{name}}” am documentat {{total}} ale femeilor originare din Republica Moldova.",
            "placeIntro": "Pentru {{name}} am documentat {{total}} ale femeilor originare din Republica Moldova care activează sau s-au remarcat în această țară.",
            "categoryBreakdown": "Țările în care activează cele mai multe dintre ele:",
            "placeBreakdown": "Domeniile cel mai des întâlnite:",
            "pageInfo": "Pagina {{page}} din {{totalPages}}",
            "prev": "← Pagina anterioară",
            "next": "Pagina următoare →",
            "empty": "Nu sunt profiluri în această secțiune.",
            "loading": "Se încarcă...",
            "seoDescription": "Toate domeniile de activitate și țările în care se remarcă femei originare din Republica Moldova: sport, muzică, medicină, business, știință, artă și altele.",
            "categorySeoDescription": "{{total}} ale femeilor din Republica Moldova care s-au remarcat în domeniul „{{name}}”: realizări, țara în care activează și surse.",
            "placeSeoDescription": "{{total}} ale femeilor originare din Republica Moldova care activează în {{name}}: domenii, realizări și surse.",
            "profiles": {
                "one": "{{count}} profil",
                "few": "{{count}} profiluri",
                "many": "{{count}} de profiluri"
            },
            "categoriesCount": {
                "one": "{{count}} domeniu",
                "few": "{{count}} domenii",
                "many": "{{count}} de domenii"
            },
            "placesCount": {
                "one": "{{count}} țară",
                "few": "{{count}} țări",
                "many": "{{count}} de țări"
            }
        },
        "notFound": {
            "title": "Pagina nu a fost găsită",
            "text": "Adresa accesată nu există sau a fost mutată.",
            "back": "← Înapoi la pagina principală",
            "directory": "Vezi domeniile și țările"
        },
        "about": {
            "title": "Despre noi",
            "sections": [
                {
                    "title": "Misiunea noastră",
                    "paragraphs": [
                        "Femei de succes din Republica Moldova este o platformă dedicată recunoașterii și promovării femeilor originare din Republica Moldova care și-au lăsat amprenta în știință, cultură, sport, afaceri, administrație, artă și alte domenii, în țară și în diaspora.",
                        "Credem că poveștile acestor femei merită să fie cunoscute, păstrate într-un singur loc și transmise generațiilor viitoare."
                    ]
                },
                {
                    "title": "Ce găsești pe platformă",
                    "paragraphs": [
                        "Profilurile sunt grupate pe domenii de activitate și pe țări, astfel încât să poți vedea, de exemplu, toate sportivele sau toate femeile din diaspora dintr-o anumită țară."
                    ],
                    "list": [
                        "Profiluri cu realizarea principală, domeniul și țara de activitate",
                        "O descriere a parcursului profesional, cu sursele pe care se bazează",
                        "Pagini pe domenii și pe țări, cu numărul de profiluri din fiecare",
                        "Rubrica „Femeia lunii” și noutăți despre femei remarcabile",
                        "Un joc de recunoaștere prin care îți poți testa cunoștințele"
                    ]
                },
                {
                    "title": "Cum alegem profilurile",
                    "paragraphs": [
                        "Includem femei născute în Republica Moldova sau cu origini moldovenești a căror activitate este documentată public: funcții de conducere sau de expertiză, premii și distincții, performanțe sportive, lucrări publicate, creații artistice ori proiecte civice cu impact.",
                        "Prezența pe platformă nu este un clasament și nu reprezintă o evaluare a persoanei; ordinea profilurilor este alfabetică sau aleatorie."
                    ]
                },
                {
                    "title": "Cum redactăm informațiile",
                    "paragraphs": [
                        "Profilurile sunt redactate pe baza informațiilor disponibile public: site-uri oficiale ale instituțiilor și companiilor, publicații de presă, pagini ale organizațiilor și profiluri profesionale publice. Acolo unde sunt disponibile, sursele sunt indicate în josul profilului, împreună cu data ultimei actualizări.",
                        "La redactare și la traducerea în limbile rusă și engleză folosim și instrumente automate. Versiunea de referință este cea în limba română; traducerile pot conține inexactități."
                    ]
                },
                {
                    "title": "Corecturi și eliminarea unui profil",
                    "paragraphs": [
                        "Depunem eforturi ca informațiile să fie corecte, însă unele date se pot schimba în timp. Dacă observi o greșeală, o informație depășită sau dorești completarea, modificarea ori eliminarea unui profil, scrie-ne prin pagina de contact. Răspundem, de regulă, în 1-3 zile lucrătoare."
                    ]
                },
                {
                    "title": "Finanțare și contact",
                    "paragraphs": [
                        "Platforma este gratuită pentru cititori. Pentru a acoperi costurile de întreținere afișăm reclame prin Google AdSense.",
                        "Ne poți scrie la ellemoldova1@gmail.com sau ne poți suna la +373 68 680 112."
                    ]
                }
            ]
        }
    },
    "rus": {
        "nav": {
            "directory": "Сферы и страны"
        },
        "home": {
            "browseCategories": "По сфере деятельности",
            "browsePlaces": "По стране",
            "browseAll": "Все сферы и страны"
        },
        "profile": {
            "category": "Сфера:",
            "sources": "Источники",
            "updated": "Последнее обновление:",
            "reportIssue": "Заметили неточность или хотите дополнить профиль?",
            "reportIssueLink": "Напишите нам"
        },
        "directory": {
            "title": "Сферы и страны",
            "breadcrumb": "Сферы и страны",
            "intro": "В нашей базе {{total}} женщин родом из Республики Молдова: {{categories}} деятельности и {{places}}, где они работают. Выберите сферу или страну, чтобы посмотреть профили.",
            "categoriesTitle": "Сферы деятельности",
            "placesTitle": "Страны",
            "categoryTitle": "{{name}} — успешные женщины из Республики Молдова",
            "placeTitle": "Успешные женщины из Республики Молдова — {{name}}",
            "categoryHeading": "Сфера: {{name}}",
            "placeHeading": "Страна: {{name}}",
            "categoryIntro": "В сфере «{{name}}» собрано {{total}} женщин родом из Республики Молдова.",
            "placeIntro": "{{name}}: {{total}} женщин родом из Республики Молдова, которые работают или добились признания в этой стране.",
            "categoryBreakdown": "Страны, где работает большинство из них:",
            "placeBreakdown": "Самые частые сферы деятельности:",
            "pageInfo": "Страница {{page}} из {{totalPages}}",
            "prev": "← Предыдущая страница",
            "next": "Следующая страница →",
            "empty": "В этом разделе пока нет профилей.",
            "loading": "Загрузка...",
            "seoDescription": "Все сферы деятельности и страны, где добились успеха женщины родом из Республики Молдова: спорт, музыка, медицина, бизнес, наука, искусство и другие.",
            "categorySeoDescription": "{{total}} женщин из Республики Молдова в сфере «{{name}}»: достижения, страна деятельности и источники.",
            "placeSeoDescription": "{{total}} женщин родом из Республики Молдова — {{name}}: сферы деятельности, достижения и источники.",
            "profiles": {
                "one": "{{count}} профиль",
                "few": "{{count}} профиля",
                "many": "{{count}} профилей"
            },
            "categoriesCount": {
                "one": "{{count}} сфера",
                "few": "{{count}} сферы",
                "many": "{{count}} сфер"
            },
            "placesCount": {
                "one": "{{count}} страна",
                "few": "{{count}} страны",
                "many": "{{count}} стран"
            }
        },
        "notFound": {
            "title": "Страница не найдена",
            "text": "Такого адреса не существует, или страница была перемещена.",
            "back": "← На главную",
            "directory": "Сферы и страны"
        },
        "about": {
            "title": "О проекте",
            "sections": [
                {
                    "title": "Наша миссия",
                    "paragraphs": [
                        "Femei de succes din Republica Moldova — платформа, посвящённая признанию и продвижению женщин родом из Республики Молдова, которые оставили след в науке, культуре, спорте, бизнесе, управлении, искусстве и других сферах — в стране и в диаспоре.",
                        "Мы считаем, что эти истории должны быть известны, собраны в одном месте и переданы будущим поколениям."
                    ]
                },
                {
                    "title": "Что есть на платформе",
                    "paragraphs": [
                        "Профили сгруппированы по сферам деятельности и по странам, поэтому можно посмотреть, например, всех спортсменок или всех женщин из диаспоры в конкретной стране."
                    ],
                    "list": [
                        "Профили с главным достижением, сферой и страной деятельности",
                        "Описание профессионального пути с указанием источников",
                        "Страницы по сферам и странам с количеством профилей",
                        "Рубрика «Женщина месяца» и обновления о выдающихся женщинах",
                        "Игра на узнавание, в которой можно проверить свои знания"
                    ]
                },
                {
                    "title": "Как мы отбираем профили",
                    "paragraphs": [
                        "Мы включаем женщин, родившихся в Республике Молдова или имеющих молдавские корни, чья деятельность подтверждена открытыми источниками: руководящие или экспертные должности, премии и награды, спортивные результаты, публикации, творческие работы или значимые общественные проекты.",
                        "Присутствие на платформе не является рейтингом и не выражает оценку личности; профили выводятся в алфавитном или случайном порядке."
                    ]
                },
                {
                    "title": "Как мы готовим тексты",
                    "paragraphs": [
                        "Профили составлены на основе открытой информации: официальных сайтов учреждений и компаний, публикаций в прессе, страниц организаций и публичных профессиональных профилей. Там, где это возможно, источники указаны внизу профиля вместе с датой последнего обновления.",
                        "При подготовке текстов и переводе на русский и английский языки мы используем в том числе автоматические инструменты. Основной считается версия на румынском языке; переводы могут содержать неточности."
                    ]
                },
                {
                    "title": "Исправления и удаление профиля",
                    "paragraphs": [
                        "Мы стараемся публиковать точную информацию, но некоторые данные со временем меняются. Если вы заметили ошибку, устаревшие сведения или хотите дополнить, изменить либо удалить профиль, напишите нам через страницу контактов. Обычно мы отвечаем в течение 1-3 рабочих дней."
                    ]
                },
                {
                    "title": "Финансирование и контакты",
                    "paragraphs": [
                        "Платформа бесплатна для читателей. Чтобы покрыть расходы на поддержку сайта, мы показываем рекламу Google AdSense.",
                        "Написать нам можно на ellemoldova1@gmail.com, позвонить — по номеру +373 68 680 112."
                    ]
                }
            ]
        }
    },
    "eng": {
        "nav": {
            "directory": "Fields & countries"
        },
        "home": {
            "browseCategories": "Browse by field",
            "browsePlaces": "Browse by country",
            "browseAll": "See all fields and countries"
        },
        "profile": {
            "category": "Field:",
            "sources": "Sources",
            "updated": "Last updated:",
            "reportIssue": "Spotted an inaccuracy or want to add to this profile?",
            "reportIssueLink": "Write to us"
        },
        "directory": {
            "title": "Fields and countries",
            "breadcrumb": "Fields and countries",
            "intro": "Our database holds {{total}} of women from the Republic of Moldova, grouped into {{categories}} of activity and {{places}} where they work. Pick a field or a country to see the profiles.",
            "categoriesTitle": "Fields of activity",
            "placesTitle": "Countries",
            "categoryTitle": "{{name}} — successful women from the Republic of Moldova",
            "placeTitle": "Successful women from the Republic of Moldova in {{name}}",
            "categoryHeading": "Field: {{name}}",
            "placeHeading": "Country: {{name}}",
            "categoryIntro": "In the field of “{{name}}” we have documented {{total}} of women from the Republic of Moldova.",
            "placeIntro": "{{name}}: {{total}} of women from the Republic of Moldova who work or have made their mark in this country.",
            "categoryBreakdown": "Countries where most of them work:",
            "placeBreakdown": "Most common fields:",
            "pageInfo": "Page {{page}} of {{totalPages}}",
            "prev": "← Previous page",
            "next": "Next page →",
            "empty": "There are no profiles in this section yet.",
            "loading": "Loading...",
            "seoDescription": "All fields of activity and countries where women from the Republic of Moldova have made their mark: sport, music, medicine, business, science, art and more.",
            "categorySeoDescription": "{{total}} of women from the Republic of Moldova in the field of “{{name}}”: achievements, country of activity and sources.",
            "placeSeoDescription": "{{total}} of women from the Republic of Moldova working in {{name}}: fields, achievements and sources.",
            "profiles": {
                "one": "{{count}} profile",
                "few": "{{count}} profiles",
                "many": "{{count}} profiles"
            },
            "categoriesCount": {
                "one": "{{count}} field",
                "few": "{{count}} fields",
                "many": "{{count}} fields"
            },
            "placesCount": {
                "one": "{{count}} country",
                "few": "{{count}} countries",
                "many": "{{count}} countries"
            }
        },
        "notFound": {
            "title": "Page not found",
            "text": "This address does not exist or the page has been moved.",
            "back": "← Back to the home page",
            "directory": "Browse fields and countries"
        },
        "about": {
            "title": "About",
            "sections": [
                {
                    "title": "Our mission",
                    "paragraphs": [
                        "Femei de succes din Republica Moldova is a platform dedicated to recognising and promoting women from the Republic of Moldova who have left their mark in science, culture, sport, business, public administration, art and other fields, at home and in the diaspora.",
                        "We believe these stories deserve to be known, kept in one place and passed on to future generations."
                    ]
                },
                {
                    "title": "What you will find here",
                    "paragraphs": [
                        "Profiles are grouped by field of activity and by country, so you can see, for example, all athletes or all women from the diaspora in a particular country."
                    ],
                    "list": [
                        "Profiles with the main achievement, field and country of activity",
                        "A description of each career path, with the sources it is based on",
                        "Field and country pages showing how many profiles each one holds",
                        "A “Woman of the Month” feature and updates about remarkable women",
                        "A recognition game to test what you know"
                    ]
                },
                {
                    "title": "How we choose profiles",
                    "paragraphs": [
                        "We include women who were born in the Republic of Moldova or have Moldovan roots and whose work is publicly documented: leadership or expert roles, awards and distinctions, sporting results, published work, artistic creations or civic projects with impact.",
                        "Being listed is not a ranking and does not express a judgement about a person; profiles are shown in alphabetical or random order."
                    ]
                },
                {
                    "title": "How the texts are written",
                    "paragraphs": [
                        "Profiles are written from publicly available information: official websites of institutions and companies, press publications, organisation pages and public professional profiles. Where available, sources are listed at the bottom of the profile together with the date of the last update.",
                        "Automated tools are also used when drafting the texts and translating them into Russian and English. The Romanian version is the reference one; translations may contain inaccuracies."
                    ]
                },
                {
                    "title": "Corrections and profile removal",
                    "paragraphs": [
                        "We work to keep the information accurate, but some details change over time. If you notice a mistake, outdated information, or would like a profile to be completed, changed or removed, write to us through the contact page. We usually reply within 1-3 working days."
                    ]
                },
                {
                    "title": "Funding and contact",
                    "paragraphs": [
                        "The platform is free for readers. To cover running costs we show advertising through Google AdSense.",
                        "You can write to us at ellemoldova1@gmail.com or call +373 68 680 112."
                    ]
                }
            ]
        }
    }
};
